import api from '~utils/http'

interface OAuth2SignInWithSamsungAccountParams {
  grant_type: 'authorization_code'
  code: string
  client_id: string
  state: string
  redirect_uri: string
  callback_uri: string
  anonymous_code: string
}

interface OtpLoginParams {
  otp: string
}

class SamsungSmartThingsAuthRepositoryImpl {
  async signInWithSamsungAccountByOAuth(params: OAuth2SignInWithSamsungAccountParams) {
    return (
      await api.post(`/st/oauth2/code/`, params, {
        withCredentials: true,
      })
    ).data
  }

  async otpLogin(params: OtpLoginParams) {
    return (
      await api.post(`/app/account/signin/st_otp/`, params, {
        withCredentials: true,
      })
    ).data
  }
}

const SamsungSmartThingsAuthRepository = new SamsungSmartThingsAuthRepositoryImpl()

export default SamsungSmartThingsAuthRepository
